import type { TableRowCellConfigExtraDataType } from 'components/editor/grid/reduxStore/table.types';

import type { TableRowType } from 'components/editor/grid/reduxStore/table.types';
import { getCommaSeparatedNumber } from 'components/editor/hooks/useFieldValidator';
import { FORMATTER_KEY } from './PricingTableTotalsFooter';
import { DOLLAR_SIGN, PERCENT_REFERENCE, PERCENT_SIGN } from '../defaultData.tsx';
type GetTotalFooterRowValueReturnType = {
  isHidden: boolean;
  displayedValue: string;
  cellConfigObject: TableRowCellConfigExtraDataType;
  valueFormatter: string;
  calculateBaseValue: string;
};

const getTotalFooterRowValue = (
  row: TableRowType,
  isCurrencySettingsEnabled = false,
  activeCurrency = DOLLAR_SIGN
): GetTotalFooterRowValueReturnType => {
  const activeCurrencySign = isCurrencySettingsEnabled ? activeCurrency : DOLLAR_SIGN;

  const calculateBaseValue = String(row[FORMATTER_KEY] ?? '');
  const cellConfigObject = (row?.cellConfig?.[FORMATTER_KEY] || {}) as TableRowCellConfigExtraDataType;
  const currencyOrPercentageSymbol = (cellConfigObject?.valueFormatter || '') as string;
  const isHidden = !!cellConfigObject?.hideCell;
  const valueFormatter = (cellConfigObject?.valueFormatter || '') as string;
  const formattedValue = getCommaSeparatedNumber(calculateBaseValue);
  const isPercent = valueFormatter === PERCENT_SIGN || valueFormatter === PERCENT_REFERENCE;
  const displayedValueWithReference = isPercent ? `${formattedValue}${PERCENT_SIGN}` : `${activeCurrency}${formattedValue}`;
  const displayedValueWithSymbol =
    currencyOrPercentageSymbol === activeCurrencySign
      ? `${currencyOrPercentageSymbol} ${formattedValue}`
      : `${formattedValue} ${currencyOrPercentageSymbol}`;
  const displayedValue = isCurrencySettingsEnabled ? displayedValueWithReference : displayedValueWithSymbol;

  return { isHidden, displayedValue, cellConfigObject, calculateBaseValue, valueFormatter };
};

export default getTotalFooterRowValue;
